import { toLower, get } from "lodash";
import { any } from "async";


export function sortByNumberReverse(numberFieldPath: string) {
  
  return (a: any, b: any): number => {
    let fA:number = get<any, string>(a, numberFieldPath);
    let fB:number = get<any, string>(b, numberFieldPath);

    if (fA === fB) {
      return 0;
    }
    // Group with higher order is first
    else if (fA < fB) {
      return 1;
    }
    else {
      return -1;
    }
  }
}

export function sortAlphabetically(stringFieldPath: string) {
  
  return (a: any, b: any): number => {
    let fA = toLower(get<any, string>(a, stringFieldPath));
    let fB = toLower(get<any, string>(b, stringFieldPath));

    if (fA === fB) {
      return 0;
    }
    else if (fA < fB) {
      return -1;
    }
    else {
      return 1;
    }
  }
}